/**
 * booking-api stores a date of birth as the unix time of UTC midnight for
 * that calendar day. `new Date(unix * 1000)` would land on the previous day
 * in browsers west of UTC, and the payload formats the date in local time.
 * Rebuild the same calendar day at local midnight instead.
 */
export const getDateOfBirthFromUnix = (unixSeconds: number): Date => {
  const utc = new Date(unixSeconds * 1000);
  return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate());
};
